import { ArrowDown, ArrowUp } from 'lucide-react'

import { TIER_PILL_CLASSES, severityTier } from '../primitives/severityTier'
import { cn } from '../../lib/utils'
import type { MappedImpactRow } from './mappers'

export function ImpactsTable({ rows }: { rows: MappedImpactRow[] }) {
  return (
    <div className="overflow-hidden rounded-lg border border-line bg-bg-elev">
      <table className="w-full border-collapse">
        <thead>
          <tr className="border-b border-line bg-bg-sunk/50">
            <th className="px-3 py-2 text-left text-10 font-semibold uppercase tracking-[0.06em] text-ink-4">
              Process
            </th>
            <th className="w-28 px-3 py-2 text-left text-10 font-semibold uppercase tracking-[0.06em] text-ink-4">
              Position
            </th>
            <th className="w-24 px-3 py-2 text-left text-10 font-semibold uppercase tracking-[0.06em] text-ink-4">
              Confidence
            </th>
            <th className="px-3 py-2 text-left text-10 font-semibold uppercase tracking-[0.06em] text-ink-4">
              Assessment
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => {
            const tier = severityTier(row.confidence)
            const pct = Math.round(Math.max(0, Math.min(1, row.confidence)) * 100)
            return (
              <tr key={`${row.process}-${i}`} className={cn(i > 0 && 'border-t border-line/60')}>
                <td className="px-3 py-2.5 align-top text-13 font-medium leading-snug text-ink">
                  {row.process}
                </td>
                <td className="px-3 py-2.5 align-top">
                  <span
                    className={cn(
                      'inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-11 font-medium',
                      row.upstream ? 'bg-st-elev-bg text-st-elev' : 'bg-bg-sunk text-ink-3'
                    )}
                  >
                    {row.upstream ? (
                      <ArrowUp aria-hidden className="size-3" />
                    ) : (
                      <ArrowDown aria-hidden className="size-3" />
                    )}
                    {row.upstream ? 'Upstream' : 'Downstream'}
                  </span>
                </td>
                <td className="px-3 py-2.5 align-top">
                  <span
                    className={cn(
                      'inline-block rounded-full px-2 py-0.5 text-11 font-semibold tabular-nums',
                      TIER_PILL_CLASSES[tier]
                    )}
                  >
                    {pct}%
                  </span>
                </td>
                <td className="px-3 py-2.5 align-top text-13 leading-relaxed text-ink-3">
                  {row.reasoning}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
